import alcaldiaLogo from '../../assets/images/medellin.png';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { httpInterceptor } from '../../API/interceptor';
import { Link, useNavigate } from 'react-router-dom';
import { useUserName } from '../../contexts/userName';
import teensImg from '../../assets/images/teens.png';
import innventaLogo from '../../assets/images/inventa-logo.png';
import seedsDef from '../../assets/images/seeds-def.png';
import './style.scss';
import {
  getSessionHomeRoute,
  setAuthToken,
  startSession
} from '../../utils/session';

export default function LoginPage() {
  // STATES //
  const [formData, setFormData] = useState({
    uid: '',
    password: ''
  });
  const navigate = useNavigate();
  const { setName, setRole, setId, ChangeUserName } = useUserName();

  // METHODS //

  function handleChange(e) {
    e.preventDefault();
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  }

  function submit(e) {
    e.preventDefault();
    if (!formData.uid) {
      toast(`Número de identificación requerido`, {
        type: 'error'
      });
    }
    if (!formData.password) {
      toast(`La contraseña es requerida`, {
        type: 'error'
      });
    }

    if (formData.uid && formData.password) {
      httpInterceptor
        .post('users/login', formData)
        .then(res => {
          if (res && res.success) {
            const user = res.data;
            setName(user.full_name);
            ChangeUserName(user.full_name);
            setRole(user.role?.name);
            setId(user.id);
            setAuthToken(user.token);
            startSession();
            navigate(getSessionHomeRoute(user.role?.name), { replace: true });
          }
        })
        .catch(() => {
          toast('Datos Invalidos Verifique', {
            type: 'error'
          });
        });
    }
  }

  return (
    <main className='login'>
      <section className='login__content content'>
        <div className='content__wrapper main'>
          <img
            src={alcaldiaLogo}
            alt='alcaldia de medellin'
            className='main__logo'
          />
          <span className='main__title'>unidad de gestión formativa</span>
          <form className='main__form form' onSubmit={e => submit(e)}>
            <label htmlFor='uid' className='form__input input'>
              <span className='material-symbols-sharp input__preffix'>
                person
              </span>
              <input
                type='string'
                name='uid'
                id='uid'
                value={formData.uid}
                onChange={e => handleChange(e)}
                placeholder='Número de identificación *'
                autoComplete='off'
              />
            </label>
            <label htmlFor='password' className='form__input input'>
              <span className='material-symbols-outlined input__preffix'>
                lock
              </span>
              <input
                type='password'
                name='password'
                value={formData.password}
                id='password'
                onChange={e => handleChange(e)}
                placeholder='Contraseña *'
                autoComplete='off'
              />
            </label>
            <button type='submit' className='ripple form__submit'>
              INGRESAR
            </button>
          </form>

          <Link to={'https://innventa.co'}>
            <div className='main__created-by by'>
              <span className='by__text'>Desarrollado por&nbsp;</span>
              <img
                src={innventaLogo}
                alt='logo innventa'
                className='by__logo'
              />
            </div>
          </Link>
        </div>
      </section>
      <section className='login__img imgs'>
        <div className='imgs__wrapper'>
          <img src={seedsDef} alt='def' className='imgs__def' />
          <img src={teensImg} alt='teens' className='imgs__teens' />
        </div>
      </section>
    </main>
  );
}
